import React from "react";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { Link } from "react-router-dom";
import { AddCircle, AttachFile, Web } from "@mui/icons-material";
import { Divider } from "@mui/material";

function CreateCourseMenu({ label }) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <Button
        id="question-filter-button"
        variant="contained"
        aria-controls={open ? "question-filter-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
        endIcon={<AddCircle />}
      >
        {label}
      </Button>
      <Menu
        id="question-filter-menu"
        aria-labelledby="question-filter-button"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        transformOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <MenuItem component={Link} to="/create-course">
          Create Course Through The Portal
          <Web fontSize="small" sx={{ ml: 0.5 }} />
        </MenuItem>
        <Divider sx={{ my: 0.5 }} />
        <MenuItem component={Link} to="/upload-course">
          Upload Course Through CSV
          <AttachFile fontSize="small" sx={{ ml: 0.5 }} />
        </MenuItem>
      </Menu>
    </>
  );
}

export default CreateCourseMenu;
